import { IoMdArrowDropdown } from "react-icons/io";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Box } from "@material-ui/core";
import voca from "voca";

import { useStyles } from "./SignupMenu.style";
import Logo from "../../logo.svg";
import { SignupContext } from "../../context/SignupContext";
import {
  useAuthenticationContext,
  userIsLoggedIn,
} from "../../context/UserContext";

export const SignupMenu = (props: any) => {
  const classes = useStyles(props);
  // Context
  const signupState = useContext(SignupContext);
  const isLoggedIn = userIsLoggedIn();
  const [user] = useAuthenticationContext();

  const renderMenu = () => {
    let userName = "";
    let profile = "";

    if (isLoggedIn) {
      userName = user.fullName();
      profile = user.avatar();
    } else {
      if (
        Boolean(signupState.personal.last_name.length !== 0) &&
        Boolean(signupState.personal.first_name.length !== 0)
      ) {
        userName = voca.titleCase(
          signupState.personal.first_name + " " + signupState.personal.last_name
        );
        profile =
          signupState.personal.profile_picture === null
            ? process.env.PUBLIC_URL + "/user_avatar.png"
            : signupState.personal.profile_picture;
      } else {
        return <ul className="pr" />;
      }
    }

    return (
      <ul className="prp">
        <li>
          <Box
            component="div"
            className="profileMenuContent"
            display="flex"
            alignItems="center"
            flexWrap="nowrap"
            justifyContent="center"
          >
            <div className="userPicture">
              <img src={profile} alt={userName} />
            </div>
            <span className="userIdentity">{userName}</span>
            <span className="arrow">
              <IoMdArrowDropdown size={14} />
            </span>
          </Box>
        </li>
      </ul>
    );
  };

  return (
    <Box
      display="flex"
      flexWrap="nowrap"
      alignItems="center"
      justifyContent="space-between"
      className={classes.root}
    >
      <Link to="#" className={classes.logoWrapper}>
        <img src={Logo} alt="ICIP Logo" />
      </Link>
      <nav className={classes.menuNav}>{renderMenu()}</nav>
    </Box>
  );
};
